<script>
import 'vue-swatches/dist/vue-swatches.min.css';
import './stylesheets/components/VsInput';

import InputMask from 'inputmask';
import Swatches from 'vue-swatches'

import FloatLabel from './FloatLabel';
import VsHelp from './VsHelp';

export default {
  components: {
    FloatLabel,
    VsHelp,
    Swatches,
  },
  props: {
    type: String,
    placeholder: String,
    value: [String, Number, Boolean, Date],
    fullWidth: [String, Boolean],
    large: [String, Boolean],
    largeOnDesktop: [String, Boolean],
    disabled: [String, Boolean],
    error: [String, Boolean],
    name: String,
    autocomplete: [String, Boolean],
    borderColor: String,
    hexColor: String,
    hexColorIsText: [String, Boolean],
    clearable: [String, Boolean],
    white: [String, Boolean],
    hideLabel: [String, Boolean],
    helpHtml: String, //only shows if input is not clearable
    mask: String,
    errorId: String,
    labelId: String,
    preventAutofill: [String, Boolean],
    readOnly: [String, Boolean],
  },
  data: () => ({
    maskRef: null,
    focused: false,
  }),
  computed: {
    tooltipInnerId() {
      return this.showToolTip ? `tooltip_inner_${this._uid}` : null;
    },
    describedById() {
      let ids = [];

      if (this.errorId) ids.push(this.errorId);
      if (this.tooltipInnerId) ids.push(this.tooltipInnerId);

      return ids.length ? ids.join(' ') : null;
    },
    showToolTip() {
      return this.helpHtml && !this.clearable;
    },
    style() {
      let style = {};

      if (this.borderColor) style.borderColor = this.borderColor;

      return style;
    },
    classes() {
      return {
        'vs-input--full-width': this.fullWidth,
        'vs-input--large': this.large,
        'vs-input--large-on-desktop': this.largeOnDesktop,
        'vs-input--error': this.error,
        'vs-input--clearable': this.clearable,
        'vs-input--white': this.white,
        'vs-input--hex': this.hexColor,
        'vs-input--search': this.type === 'search',
        'vs-input--disabled': this.disabled,
        'floatl__input': !this.hideLabel,
        'vs-input--no-z': this.hexColor,
      };
    },
    vuexHexColor: {
      get() {
        return this.hexColor;
      },
      set(value) {
        this.$emit('input', { target: { value } });
      },
    },
    readonly() {
      return (!this.focused && this.preventAutofill) || this.readOnly || this.disabled;
    },
  },
  watch: {
    mask() {
      this.$_deleteMask();
      this.$_createMask();
    },
  },
  mounted() {
    this.$_createMask();
  },
  beforeDestroy() {
    this.$_deleteMask();
  },
  methods: {
    $_createMask() {
      if (this.mask) {
        this.maskRef = new InputMask({ mask: this.mask, greedy: false, clearMaskOnLostFocus: true });
        this.maskRef.mask(this.$el.querySelector('.vs-input'));
      }
    },
    $_deleteMask() {
      if (this.maskRef) {
        this.maskRef.remove();
        this.maskRef = null;
      }
    },
    handleClear(e) {
      e.target.value = '';

      if (this.type === 'search') {
        this.$emit('search', e);
      } else {
        this.$emit('input', e);
      }
    },
    focusIn() {
      this.focused = true;
    },
    focusOut(e) {
      this.focused = false;

      this.$emit('blur', e);
    },
  },
};
</script>

<template lang='pug'>
float-label(
  :large='large',
  :large-on-desktop='largeOnDesktop',
  :full-width='fullWidth',
  :placeholder='placeholder',
  :value='value',
  :hide-label='hideLabel',
  :type='type',
)
  input.vs-input(
    :type='type || "text"',
    :value='value',
    :style='style',
    :class='classes',
    :name='name',
    :aria-label='placeholder',
    :aria-describedby='describedById',
    :aria-invalid='error ? "true" : "false"',
    :aria-disabled='disabled ? "true" : "false"',
    :aria-required='!!errorId',
    :autocomplete='autocomplete',
    :readonly='readonly',
    :placeholder='hideLabel ? placeholder : null',
    @input='$emit("input", $event)',
    @keyup.enter='$emit("search", { target: { value } })',
    @focus='focusIn',
    @blur='focusOut',
  )

  //- search button
  .vs-input__search.mdi.mdi-magnify(
    v-if='type === "search"',
    @click='$emit("search", { target: { value } })',
  )

  //- close button
  .vs-input__clear.mdi.mdi-close(
    v-if='clearable && value',
    @click='handleClear',
  )

  //- help icon on hover
  .vs-input__help(
    v-if='showToolTip',
  )
    vs-help(
      :message='helpHtml',
      :tooltip-inner-id='tooltipInnerId',
    )

  //- color box appended
  swatches(
    v-if='hexColor',
    v-model='vuexHexColor',
    popover-to='right',
    :colors='hexColorIsText ? "text-basic" : "basic"',
  )
    .vs-input__hex(
      slot='trigger',
      :style='{ "backgroundColor": hexColor }',
    )
</template>